module.exports = __webpack_public_path__ + "img/tp-cup.caf269b1.jpg";